import { useEffect, useState, createContext, useContext } from 'react';

const ModeContext = createContext();

const ModeContextProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(() => {
    // Initialisation depuis le localStorage
    const savedMode = localStorage.getItem('displayMode');
    if (savedMode) {
      return savedMode === 'dark';
    } else {
      // Définit le mode par défaut à "dark"
      localStorage.setItem('displayMode', 'dark');
      return true;
    }
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('displayMode', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('displayMode', 'light');
    }
  }, [darkMode]);

  return (
    <ModeContext.Provider value={{ darkMode, setDarkMode }}>
      {children}
    </ModeContext.Provider>
  );
};

export default ModeContextProvider;

export const UserMode = () => {
  return useContext(ModeContext);
};
